module.exports = __webpack_public_path__ + "img/Beauty Treatments 3.d9dd95ee.jpg";